import { DocumentUpload, Warning2 } from "iconsax-react";
import { Button, Form, Input, Select, Upload } from "antd";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  ref as sRef,
  uploadBytes,
  getDownloadURL,
  getStorage,
} from "firebase/storage";
import Swal from "sweetalert2";
import { useSinalario } from "../../../hooks/sinalario";
import { useProfiles } from "../../../hooks/profile";
import { useAuth } from "../../../hooks/auth";

import MobileLayout from "../../../components/MobileLayout";
import { Main, MediaPreviewSquare } from "./styles";

export interface FormProps {
  palavra: string;
  categoria: string;
  letra?: string;
  descricao: string;
  image: string;
  video: string;
}

function geraStringAleatoria(tamanho: number) {
  let stringAleatoria = "";
  const caracteres =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (let i = 0; i < tamanho; i += 1) {
    stringAleatoria += caracteres.charAt(
      Math.floor(Math.random() * caracteres.length)
    );
  }
  return stringAleatoria;
}

function AddVerbete() {
  const { TextArea } = Input;
  const { createVerbete, loadingVerbetes } = useSinalario();
  const [letra, setLetra] = useState("Selecione uma família de letras");
  const [image, setImage] = useState("");
  const [video, setVideo] = useState("");
  const { getAll } = useProfiles();
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    async function loadData() {
      if (!user?.uid) return;
      try {
        await getAll(user.uid);
      } catch (error) {
        console.error("Failed to load user data:", error);
        navigate("/");
      }
    }
    loadData();
  }, [getAll, navigate, user?.uid]);

  const handleCreateVerbete = useCallback(
    async ({ descricao, letra, palavra }: FormProps) => {
      if (!image) {
        Swal.fire(
          "Atenção",
          "Por favor, aguarde o upload da imagem antes de salvar.",
          "warning"
        );
        return;
      }
      if (!video) {
        Swal.fire(
          "Atenção",
          "Por favor, aguarde o upload do vídeo antes de salvar.",
          "warning"
        );
        return;
      }
      try {
        console.log("chegou");
        await createVerbete({
          descricao,
          image,
          letra,
          palavra,
          video,
          categoria: "",
        });
      } catch (error) {
        console.log(error);
      }
    },
    [createVerbete, image, video]
  );

  // Removed unused onPreview function

  const customUploadImage = async ({ file, onSuccess, onError }: any) => {
    const storage = getStorage();
    const metadata = {
      contentType: "image/jpeg",
    };

    const nick = geraStringAleatoria(16);
    if (!user?.uid) return;
    const fileName = user.uid;
    const imgFile = sRef(storage, `sinalario/images/${fileName + nick}.png`);
    Swal.fire({
      title: "Realizando envio da imagem...",
      showConfirmButton: false,
      allowEscapeKey: false,
      allowOutsideClick: false,
      didOpen: async () => {
        Swal.showLoading();
        try {
          await uploadBytes(imgFile, file, metadata);
          const downloadUrl = await getDownloadURL(imgFile);
          setImage(downloadUrl);
          if (onSuccess) onSuccess("ok");
          Swal.close();
          Swal.fire({
            icon: "success",
            showConfirmButton: false,
            timer: 1000,
          });
        } catch (e) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Aconteceu algum erro inesperado.\nTente novamente.",
          });
          console.log(e);
          if (onError) onError(e);
        }
      },
    });
  };

  const customUploadVideo = async ({ file, onSuccess, onError }: any) => {
    const storage = getStorage();
    const metadata = {
      contentType: file.type || "video/mp4",
    };

    const nick = geraStringAleatoria(16);
    if (!user?.uid) return;
    const fileName = user.uid;
    const videoFile = sRef(storage, `sinalario/videos/${fileName + nick}.mp4`);
    Swal.fire({
      title: "Realizando envio do vídeo...",
      showConfirmButton: false,
      allowEscapeKey: false,
      allowOutsideClick: false,
      didOpen: async () => {
        Swal.showLoading();
        try {
          await uploadBytes(videoFile, file, metadata);
          const downloadUrl = await getDownloadURL(videoFile);
          setVideo(downloadUrl);
          if (onSuccess) onSuccess("ok");
          Swal.close();
          Swal.fire({
            icon: "success",
            showConfirmButton: false,
            timer: 1000,
          });
        } catch (e) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Aconteceu algum erro inesperado com o upload do vídeo.\nTente novamente.",
          });
          console.log(e);
          if (onError) onError(e);
        }
      },
    });
  };

  return (
    <MobileLayout headerTitle="Sinalário" headerType="private">
      <Main>
        <Form onFinish={handleCreateVerbete}>
          <fieldset>
            <legend>Dados do Verbete</legend>
            <Form.Item
              label="Título do verbete ou palavra"
              name="palavra"
              rules={[{ required: true, message: "Este Campo é Obrigatório" }]}
            >
              <Input
                id="palavra"
                name="palavra"
                type="text"
                placeholder="Insira o titulo do verbete"
              />
            </Form.Item>

            <Form.Item
              label="Descrição curta do verbete"
              name="descricao"
              rules={[{ required: true, message: "Este Campo é Obrigatório" }]}
            >
              <TextArea
                id="descricao"
                name="descricao"
                placeholder="Insira a descrição do verbete"
                maxLength={200}
                showCount
              />
            </Form.Item>
            <Form.Item
              label="Categoria do verbete"
              name="letra"
              rules={[{ required: true, message: "Este Campo é Obrigatório" }]}
            >
              <Select
                id="letra"
                defaultValue="Selecione uma opção"
                onChange={(value) => {
                  setLetra(value);
                }}
                value={letra || undefined}
                options={[
                  { value: "A", label: "A" },
                  { value: "B", label: "B" },
                  { value: "C", label: "C" },
                  { value: "D", label: "D" },
                  { value: "E", label: "E" },
                  { value: "F", label: "F" },
                  { value: "G", label: "G" },
                  { value: "H", label: "H" },
                  { value: "I", label: "I" },
                  { value: "J", label: "J" },
                  { value: "K", label: "K" },
                  { value: "L", label: "L" },
                  { value: "M", label: "M" },
                  { value: "N", label: "N" },
                  { value: "O", label: "O" },
                  { value: "P", label: "P" },
                  { value: "Q", label: "Q" },
                  { value: "R", label: "R" },
                  { value: "S", label: "S" },
                  { value: "T", label: "T" },
                  { value: "U", label: "U" },
                  { value: "V", label: "V" },
                  { value: "W", label: "W" },
                  { value: "X", label: "X" },
                  { value: "Y", label: "Y" },
                  { value: "Z", label: "Z" },
                ]}
              />
            </Form.Item>

            <Form.Item label="Imagem representativa do verbete">
              {image && (
                <MediaPreviewSquare>
                  <img src={image} alt="Preview" loading="lazy" />
                </MediaPreviewSquare>
              )}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                  width: "100%",
                }}
              >
                <Input
                  id="imageUrl"
                  placeholder="Insira a URL da imagem ou anexe um arquivo"
                  value={image}
                  onChange={(e) => setImage(e.target.value)}
                  style={{ height: "4.8rem", borderRadius: "0.8rem" }}
                />
                <Upload
                  id="imageUploadBtn"
                  accept=".png, .jpg, .jpeg"
                  name="picture"
                  maxCount={1}
                  customRequest={customUploadImage}
                  style={{ width: "100%" }}
                  showUploadList={false}
                >
                  <Button
                    htmlType="button"
                    style={{
                      width: "100%",
                      textAlign: "center",
                      height: "4.8rem",
                      borderRadius: "0.8rem",
                    }}
                    icon={<DocumentUpload size={18} />}
                  >
                    Anexar imagem (Upload)
                  </Button>
                </Upload>
              </div>
            </Form.Item>

            <Form.Item label="Video de representação do verbete">
              {video && (
                <MediaPreviewSquare>
                  <video src={video} controls preload="metadata" playsInline>
                    <track kind="captions" />
                  </video>
                </MediaPreviewSquare>
              )}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                  width: "100%",
                }}
              >
                <Input
                  id="videoUrl"
                  placeholder="Insira a URL do vídeo ou anexe um arquivo"
                  value={video}
                  onChange={(e) => setVideo(e.target.value)}
                  style={{ height: "4.8rem", borderRadius: "0.8rem" }}
                />
                <Upload
                  id="videoUploadBtn"
                  accept=".mp4, .mov, .avi"
                  name="video"
                  maxCount={1}
                  customRequest={customUploadVideo}
                  style={{ width: "100%" }}
                  showUploadList={false}
                >
                  <Button
                    htmlType="button"
                    style={{
                      width: "100%",
                      textAlign: "center",
                      height: "4.8rem",
                      borderRadius: "0.8rem",
                    }}
                    icon={<DocumentUpload size={18} />}
                  >
                    Anexar vídeo (Upload)
                  </Button>
                </Upload>
              </div>
            </Form.Item>
          </fieldset>
          <footer>
            <p>
              <Warning2 size={48} />
              Atenção! <br />É necessário preecher todos os dados.
            </p>
            <Button htmlType="submit" disabled={loadingVerbetes}>
              Criar verbete
            </Button>
          </footer>
        </Form>
      </Main>
    </MobileLayout>
  );
}
export default AddVerbete;
